import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthGaurdService } from './auth-gaurd.service';
import { Observable } from 'rxjs';
import { CommPlan } from '../models/commission/comm-plan.model';
import { environment } from '../../environments/environment';
import { CommPlanDetail } from '../models/commission/comm-plan-detail.model';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { KomFeed } from '../models/commission/kom-feed.model';
import { ComboDetails } from '../models/commission/combo-details.model';
import { BossCallMapping } from '../models/commission/boss-call-mapping.model';
import { CallDetails } from '../models/commission/call-details.model';

@Injectable({
    providedIn: 'root'
})
export class BossCallMappingService {

    host: string = environment.apiUrl + 'bosscallmapping';
    tokenId: string = '';
    commModel = new CommPlan();
    kpiDetails: CommPlanDetail[] = [];
    salesChannels: string[] = [];
    commData: CommPlan[] = [];
    komFeedModel = new KomFeed();
    editKomFeedModel = new KomFeed();
    loggedinUser: string = '';
    languages: string[];
    payrollCalender: string[];
    salesRepData: KomFeed[];
    callDetailModel = new CallDetails();

    constructor(private http: HttpClient, private authGaurdService: AuthGaurdService) {
        this.tokenId = this.authGaurdService.getToken();
    }

    public saveCallMapData(bossCallMdl: BossCallMapping): Observable<ComboDetails> {
        return this.http.post<ComboDetails>(`${this.host}/savecalldata`, bossCallMdl);
    }

    public updateCallMapData(bossCallMdl: BossCallMapping): Observable<CustomHttpRespone> {
        return this.http.put<CustomHttpRespone>(`${this.host}/updatecallmapping`, bossCallMdl);
    }
    public getSearchResults(feedDate: any): Observable<BossCallMapping[]> {
        return this.http.get<BossCallMapping[]>(`${this.host}/getcallmapingdata` + feedDate);
    }
    public deleteCallMapData(networkid: string, validFromDt: any): Observable<CustomHttpRespone> {
        let url = this.host + '/deletecallmapdata/' + networkid + '/' + validFromDt;
        return this.http.delete<CustomHttpRespone>(url);
    }

    public saveEmailId(bossCallMdl: BossCallMapping): Observable<ComboDetails> {
        return this.http.post<ComboDetails>(`${this.host}/saveemailid`, bossCallMdl);
    }
    public sendEmail(bossCallMdl: BossCallMapping): Observable<ComboDetails> {
        return this.http.post<ComboDetails>(`${this.host}/sendemail`, bossCallMdl);
    }
    public getEmail() {
        const url = this.host + '/getemail';
        return this.http.get(`${url}`, { responseType: 'text' });
    }

}